export default __webpack_public_path__ + "49c6d834d0464a4fc8265895de84307d.svg";